import React from "react";
import { Link } from "react-router-dom";

import pohori_1 from "../../public/pohori_beskydy/pohori_1.png";
import pohori_2 from "../../public/pohori_beskydy/pohori_2.png";
import pohori_3 from "../../public/pohori_beskydy/pohori_3.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const Beskydy = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={darkMode ? "pohori dark" : "pohori light"}>
        <div className="container">
          <div className="pohori-container">
            <div className="pohori-image">
              <img src={pohori_1} alt="" />
            </div>
            <div className="pohori-content">
              <h1 className={darkMode ? "dark-text" : "light-text"}>Beskydy</h1>
            </div>
          </div>
        </div>
      </section>

      <section className={darkMode ? "pohori-trip dark" : "pohori-trip light"}>
        <div className="container">
          <div className="pohori-trip-container">
            <div className="pohori-trip-content">
              <h2 className={darkMode ? "dark-text" : "light-text"}>
                Kam se vydat v Beskydech?
              </h2>
              <p
                className={darkMode ? "dark-second-text" : "light-second-text"}
              >
                Moravskoslezské Beskydy jsou krásným pohořím rozkládajícím se v
                kopcích východní části České republiky. Poskytují úchvatné
                výhledy na Slovensko i Polsko. Ať už se chystáte na jednodenní
                výlet nebo na delší pobyt, Moravskoslezské Beskydy nabízejí řadu
                aktivit a zážitků.
              </p>
              <Link
                className={darkMode ? "dark-button-text" : ""}
                to="/beskydy/kamsevydat"
              >
                <span>Více</span>
              </Link>
            </div>
            <div className="pohori-trip-image">
              <img src={pohori_2} alt="" />
            </div>
          </div>
        </div>
      </section>

      <section
        className={darkMode ? "pohori-nature dark" : "pohori-nature light"}
      >
        <div className="container">
          <div className="pohori-nature-container">
            <div className="pohori-nature-image">
              <img src={pohori_3} alt="" />
            </div>
            <div className="pohori-nature-content">
              <h2 className={darkMode ? "dark-text" : "light-text"}>
                Příroda v Beskydech
              </h2>
              <p
                className={darkMode ? "dark-second-text" : "light-second-text"}
              >
                CHKO Beskydy je svou rozlohou 1 160 km² největší chráněnou
                krajinnou oblastí v České republice. Naleznete zde původní
                pralesovité porosty, horské louky s výskytem vzácných
                karpatských rostlin a živočichů i unikátní pseudokrasové jevy.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Beskydy;
